import React, { useState } from "react";
import { FiMoreVertical } from "react-icons/fi";
import Popover from "../../../../components/shared/Popover/Popover";

function VideoActionMenu({ onDownload }) {
  const [open, setOpen] = useState(false);

  return (
    <Popover
      isOpen={open}
      onClose={() => setOpen(false)}
      contentClassName="w-40 overflow-hidden rounded-lg border border-gray200 bg-white shadow-lg z-20"
      trigger={
        <button
          aria-label="Open actions"
          className="rounded-full p-1.5 text-gray600 transition-colors hover:bg-gray100 hover:text-primary700"
          onClick={() => setOpen((v) => !v)}
          type="button"
        >
          <FiMoreVertical className="size-5" />
        </button>
      }
    >
      {onDownload && (
        <button
          className="w-full px-4 py-2.5 text-left text-base text-gray800 hover:bg-gray50"
          onClick={() => {
            setOpen(false);
            onDownload?.();
          }}
          type="button"
        >
          Download video
        </button>
      )}
    </Popover>
  );
}

export default VideoActionMenu;
